<template>
	<div id="app" class="flex-container flex-align-top flex-direction-row">
		<sidebar-wrapper />
		<toast-wrapper />
		<modal-manager />
		<router-view />
		<server-status-badge />
	</div>
</template>

<script>
import SidebarWrapper from "@/spa/components/sidebar/SidebarWrapper";
import ToastWrapper from "@/spa/components/toast/ToastWrapper";
import ModalManager from "@/spa/components/modal/ModalWrapper";

import ServerStatusBadge from "@/modules/ServerStatusBadge";
import axios from "axios";

export default {
	name: "App",
	components: {
		SidebarWrapper,
		ToastWrapper,
		ModalManager,
		ServerStatusBadge
	},
	mounted() {
		console.log("AppMounted", process.env.NODE_ENV);
		if (process.env.NODE_ENV == "development") {
			console.log("dev");
			// url = "http://localhost:3000" + url
			axios.defaults.baseURL = "http://localhost:3000";
		} else {
			console.log("not dev");
		}
	}
};
</script>

<style lang="scss">
#app {
	width: 100%;
	height: auto;
	text-align: center;
	margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue